export default "__VITE_ASSET__BT1e$PLM__"